import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface Event {
  id: string;
  nome_evento: string;
  data_evento: string;
  local_evento: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  bandas: string;
  informacoes_adicionais?: string;
  contato_info?: string;
  imagem_url?: string;
  approved_at: string;
}

const EVENTS_QUERY_KEY = ['approved-events'];

export const useEventsQuery = () => {
  const { data: events = [], isLoading, error } = useQuery({
    queryKey: EVENTS_QUERY_KEY,
    queryFn: async () => {
      const { data, error } = await supabase
        .rpc('get_public_approved_events');

      if (error) throw error;
      return (data || []) as Event[];
    },
  });

  return {
    events,
    isLoading,
    error,
  };
};
